import * as z from 'zod';

export type SubscriptionItemUsageRecordFormSchemaValues = z.infer<typeof subscriptionItemUsageRecordFormSchema>;
export const subscriptionItemUsageRecordFormSchema = z
    .object({
        recorded_at: z.string().nonempty(),
        quantity: z.int().min(0),
        billing_period_start: z.string().nonempty(),
        billing_period_end: z.string().optional().nullable(),
    })
    .refine((data) => !data.billing_period_end || data.billing_period_start < data.billing_period_end, {
        path: ['billing_period_end'],
        message: 'Must be after the period start.',
    });
